import React, { useEffect, useState } from "react";
import uiConfig from "../../config/uiConfig";

import { Button } from "@mui/material";

import { useMsal } from "@azure/msal-react";

import { loginRequest } from "../../auth/msalConfig";

function LoginButton() {
  const { instance, accounts } = useMsal();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (accounts.length > 0) {
      console.log("Existing user:", accounts[0]);
    }
  }, [accounts]);

  // const handleLogin = async () => {
  //   try {
  //     if (accounts.length > 0) {
  //       console.log("User already logged in");

  //       window.location.href = "/dashboard";

  //       return;
  //     }

  //     setLoading(true);

  //     const response = await instance.loginPopup(loginRequest);

  //     console.log("LOGIN SUCCESS", response);

  //     window.location.href = "/dashboard";
  //   } catch (error) {
  //     console.error("LOGIN ERROR:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
 
    try {
      // Use loginRedirect - more reliable than popup for B2C
      await instance.loginRedirect(loginRequest);
      // Note: page will navigate away to Azure AD - code below won't run
    } catch (err) {
      console.error('❌ Login error:', err);
      if (err.errorCode === 'interaction_in_progress') {
        setError('Another login attempt is in progress. Please wait.');
      } else {
        setError(`Login failed: ${err.errorMessage || err.message || 'Unknown error'}`);
      }
      setLoading(false);
    }
  };
 
  // Navigate to dashboard once authenticated
 

  return (
    <Button
      variant="contained"
      disabled={loading}
      onClick={handleLogin}
      sx={{
        background: uiConfig.buttonColor,

        textTransform: "none",

        fontWeight: 600,

        px: 3,

        py: 1.2,

        borderRadius: 2,
      }}
    >
      {loading ? "Signing in..." : "Login with Microsoft"}
    </Button>
  );
}

export default LoginButton;
